declare const global: any;

export const isDesktop = (): boolean => {
	return !!global?.window?.desktopNativeBridge;
};
